import { Validator } from 'vee-validate';
import i18n from '@/i18n/i18n';
import { passwordRegex } from '@/util/util.regex';

Validator.extend('password', {
  getMessage: (field) => i18n.t('$Validators.password', { field }),
  validate: (value) => passwordRegex.test(value),
});
